import React from "react";
import { Router } from "@reach/router";
import Leaderboard from "./components/Leaderboard";
import Admin from "./components/Admin";
import "semantic-ui-css/semantic.min.css";

function App() {
  const adminView = true;
  return (
    <Router>
      <Leaderboard path="/" adminView={!adminView} />
      <Leaderboard path="/account-managers" adminView={adminView} />
      <Admin path="/admin" adminView={!adminView} />
      <Admin path="/account-managers/admin" adminView={adminView} />
    </Router>
  );
}

export default App;
